export const GET_CURRENT_MEDIA_ITEM = "GET_CURRENT_MEDIA_ITEM";
export const REFRESH_CURRENT_MEDIA_ITEM = "REFRESH_CURRENT_MEDIA_ITEM";
export const RESET_CURRENT_MEDIA_ITEM = "RESET_CURRENT_MEDIA_ITEM";
export const SET_CURRENT_MEDIA_ITEM_REQUEST_STATUS = "SET_CURRENT_MEDIA_ITEM_REQUEST_STATUS";
